/// <reference path="../../typings/browser.d.ts" />
/// <reference path="../../customtypings/window.d.ts" />

/**
 * Action service
 */
namespace Application.Services {
    'use strict';

    /**
     * LocationChangerService
     */
    export class LocationChangerService {
        public static $name: string = "locationChangerService";
        public static $inject: string[] = ['$location', '$route', '$rootScope'];

        private $location: ng.ILocationService;
        private $route: ng.route.IRouteService;
        private $rootScope: ng.IRootScopeService;

        constructor($location: ng.ILocationService,
                    $route: ng.route.IRouteService,
                    $rootScope: ng.IRootScopeService) {
            this.$location = $location;
            this.$route = $route;
            this.$rootScope =  $rootScope;
        }
        
        
        public skipReload(): ng.ILocationService {
            let lastRoute: ng.route.ICurrentRoute = this.$route.current;
            
            this.$rootScope.$on('$locationChangeSuccess', () => {
                this.$route.current = lastRoute;
            });
            return this.$location;
        }
        
        public location(): ng.ILocationService {
            return this.$location;
        }
    }
}